<div id="container">
  <app-navbar class="max-md:tw-sticky max-md:tw-top-0 max-md:tw-z-20 max-md:tw-bg-white"></app-navbar>
  <router-outlet />
<!--  <letly-breadcrumb></letly-breadcrumb>-->
</div>
<app-bottom-navbar></app-bottom-navbar>
@if (consentUiMode === 'banner' && consentService.shouldPrompt()) {
  <app-consent-banner></app-consent-banner>
}
